module.exports = __webpack_public_path__ + "static/todoist-c36d8c367d755c254422f8f088ae9c3c.png";